<template>
	<div class="qualityenterprise" v-title data-title="外资企业">
		<leftnav class="fl" :mkcode="curWebsite.type == 5 ? 'DB':'A'" itemcode="A-WZQY"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>                                      
			</el-dialog>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox" style="padding-bottom: 1px;">
					<div class="right_boxtitle">
						<span class="fl right_title">企业</span>
						<div class="fl search-box ot-search-box">
							<span class="searchtype">{{title}}</span>
							<input type="text" placeholder="请输入企业名称" class="search-input" v-model="searchtext"	@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div>
					</div> 
				<div class="opport-screen-list1"> 
							<dl class="opport-screen bdbe">
								<dt class="fl">企业类型</dt>
								<dd class="fl" v-if="curWebsite.type != 5"> 
									<span v-for="(item,index) in enterinarr" @click="routerself('/enterpriseList?type='+item.type)" :key="index" class="a-screen">{{item.name}}</span>
									<span @click="routerself('/totalEnterprises')" class="a-screen">全部内资企业库</span>
									<span class="blueline"></span>
									<span @click="routerself('/foreignEnterprises')" class="a-screen">境外上市企业库</span> 
									<span class="a-screen current">外资企业库</span>  
									<!-- <el-tooltip class="item smartTip-text" effect="light" placement="top-start"><i	class="el-icon-question listeltootipicon" ></i>
										<div slot="content" class="list_tips">
											<p>上市公司：A股上市的公司 </p>
											<p>龙头企业：规模大、投资实力强、在行业内占据优势地位的企业</p>
											<p>创新企业：被专业投资机构认可并成功融资的企业</p>
											<p>优质企业：具有市场竞争优势和持续发展潜力的企业</p>
											<p>外资企业：外商投资的企业</p>
											<p>境外上市企业：在境外证券交易所公开上市的企业</p> 
										</div>
									</el-tooltip> -->
										<video-teaching :type="1"></video-teaching>
								</dd>
								<dd class="fl" v-if="curWebsite.type == 5">
									<span :key="index" v-for="(item,index) in tz_enterinarr" @click="routerself('/markingEnterpriseist?type='+item.type);" class="a-screen">{{item.name}}</span> 
									<span class="blueline"></span>
									<span @click="routerself('/foreignEnterprises')" class="a-screen">境外上市企业</span> 
									<span class="a-screen current">外资企业</span>  
									<el-tooltip class="item smartTip-text" effect="light" placement="top-start"><i
											class="el-icon-question listeltootipicon"></i>
										<div slot="content" class="list_tips">
											<p>上市公司：A股上市的公司 </p>
											<p>龙头企业：规模大、投资实力强、在行业内占据优势地位的企业</p> 
											<p>外资企业：外商投资的企业</p>
											<p>境外上市企业：在境外证券交易所公开上市的企业</p>
										</div>
									</el-tooltip>
								</dd>
							</dl>
							<dl class="opport-screen bdbe" v-if="curWebsite.type != 5">
								<dt class="fl">企业类型</dt>
								<dd class="fl">
									<span class="a-screen current">外资企业</span>
									<span class="a-screen" @click="isShowFreeUserTips = true">外商投资企业</span>
									<span class="fl dib py-1 ml-5 orgfont">
										在国内已投资的所有外资企业（含独资及合资），可查询总部，还可以分城市、分行业查询，外商投资布局一目了然！ 
									</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe">
								<dt class="fl">级别</dt>
								<dd class="fl"> 
									<span v-for="(item,index) in levelList"	@click="getLevelId(item.code);"	:class="item.code == levelid?'a-screen current' : 'a-screen'">{{item.text}}</span>
									<el-tooltip class="item smartTip-text" effect="light" placement="top-start"><i	class="el-icon-question listeltootipicon" ></i>
										<div slot="content" class="list_tips">
											<p>中国总部：根据公开数据判断外国企业疑似在中国的总部，可能与实际情况不一致</p> 
										</div>
									</el-tooltip>
								</dd>
							</dl>
							<dl class="opport-screen bdbe">
								<dt class="fl">省份地区</dt>
								<dd class="fl">
									<span :class="provinceid == 0?'current a-screen':'a-screen'" @click="provincechoose(0,'all');">全国地区</span>
									<span v-for="(item,index) in provincedata"	@click="provincechoose(item.areaId,index);"	:class="item.areaId == provinceid?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe" v-show="citydata.length!=0">
								<dt class="fl">城市地区</dt>
								<dd class="fl">
									<span :class="cityid == 0?'current a-screen':'a-screen'"	@click="choosecity(0,'all');">全部</span>
									<span v-for="(item,index) in citydata"	@click="choosecity(item.areaId,index);cityid=item.areaId;":data="item.areaId"	:class=" item.areaId == cityid ?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
								</dd>
							</dl> 
							<dl class="opport-screen bdbe" v-show="hotindustry.length>0">
								<dt class="fl">产业分类</dt>
								<dd class="fl">
									<span :class="industrycode1 == ''?'a-screen current':'a-screen'" @click="getIndustryId(2,'');">全部</span>
									<span v-for="(item,index) in hotindustry" v-show="item.num>0"  @click="getIndustryId(2,item.industry);" :class="industrycode1 == item.industry?'a-screen current':'a-screen'">{{item.text}}<em class="num" v-show="levelid==0">({{item.num}})</em></span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe" v-show="hotindustrychild.length>0">
								<dt class="fl titleop">细分产业</dt>
								<dd class="fl"> 
									<span :class="industrycode2 == ''?'a-screen current':'a-screen'" @click="getIndustryId(3,'');">全部</span>
									<span v-for="(item,index) in hotindustrychild" v-show="item.num>0" @click="getIndustryId(3,item.industry);" :class="industrycode2 == item.industry?'a-screen current':'a-screen'">{{item.text}}<em class="num" v-show="levelid==0">({{item.num}})</em></span>
								</dd>
							</dl>
							<!-- <dl class="opport-screen bdbe">
								<dt class="fl">产业分类</dt>
								<dd class="fl">
									<span v-for="(item,index) in hotindustry" @click="industrychoose(1,item);" :class="industrycode1 == item.value?'a-screen current':'a-screen'">{{item.name}}</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe" v-show="hotindustrychild.length>0">
								<dt class="fl titleop">细分产业</dt>
								<dd class="fl"> 
										<span v-for="(item,index) in hotindustrychild" @click="industrychoose(2,item);" :class="industrycode2 == item.value?'a-screen current':'a-screen'">{{item.name}}</span>
								</dd>
							</dl> -->
						</div>
					</div> 
				<div class="whitebox" style="min-height: 160px;" :data="exportnum">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
						<p class="fl" v-if="kwtextsearch">产业大脑为您找到<span 	class="searchnum">{{total}}</span>条【 <span class="orangefont">{{kwtextsearchtext}}</span>】相关结果</p>
						<!-- <div :class="exportbtn?'fr enlistexportbtn':'fr enlistexportbtn disable'" 	@click="enlistExport()" v-if="userdata.groupType == 1" v-show="exportnum>0 && enterpristlist.length>0">
							<span>导出数据</span></div> -->
					</div> 
					<!-- 多维度分数筛选 --> 
					<ul class="dimensionScreen oh w95mg" v-show="enterpristlist.length>0"> 
						<li :class="orderField == list.type ?'fl current ':'fl '"   v-for="(list,index) in dimensionList" @click="tablesort(list.type);" v-show="list.name!='融资时间'||searchtype == 2"> 
							<span 	:class="{'sortname ':true,'current':orderField == list.type,'fz15':list.name.length>5}">{{list.name}}</span> 
							<span :class="orderType == 1?'timesorticon up':'timesorticon down'"></span> 
						</li> 
					</ul> 
					<div class="enterprise_list_box" v-show="enterpristlist.length!=0"> 
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th class="xuhaotd">排序</th>
								<th style="width:200px;">企业名称</th>
								<th style="width:250px;">所属产业</th>
								<!-- <th>画像标签</th> -->
								<th>地区</th>
								<th>注册资本</th>
								<!-- <th>编辑</th> -->
							</tr> 
							<tr v-for="(list,index) in enterpristlist">
								<td>{{(page-1)*pageSize+index+1}}</td>
								<!--  -->
								<td class="title"@click="routerlinkid('/enterprises',list.stockCode,curindex)" >{{list.title}} </td>
								<td class="">
									{{list.industry.length>0?list.industry:'-'}}
								</td>
								<!-- <td class="conpanytags "> 
									<span class="span-tag" v-for="item in list.taglist"@click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name,'quality1')">{{item.name}}</span>
								</td> -->
								<td>{{list.area}}</td>
								<td>	{{list.regCapital.length>0?list.regCapital:'-'}} </td>
								<!-- <td class="collectfont1"><span  @click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br/>目标企业</span></td> -->
							</tr>
						</table> 
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"	v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>
			</div>
		</div>
		<!-- 导出列表弹框 -->
		<div class="enlistexportPop" v-show="exportpop">
			<div class="enlistexportPop_box">
				<h5 class="title">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</h5>
				<p class="smtips">单次最多导出500条，每日最多可以导出10次</p>
				<p class="tips">本次可导出<b class="redfont">{{total>500?500:total}}</b>条，今日剩余次数<b class="redfont">{{exportnum}}</b>次</p>
				<span class="determinebtn" @click="exportlistFun()">{{confirmtext}}</span>
				<span class="closebtn" @click="exportpop=false"></span>
			</div>
		</div>
		<iframe :src='iframeurl' style="width: 1px;height: 1px;" frameborder="none" id="exportIframe"></iframe>
	</div>
	</div>
</template>

<script>
	import {
		dataInJs
	} from "../../utils/city.js";
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'forcapEnterprise',
		computed: {
		...mapState({
		// isCollapse: (state) => state.app.isCollapse,
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				title: "外资企业库",
				curWebsite:this.$api.getWebsiteType(),   
				industrytype:1,
				enterinarr: [
				{curindex: 1,type: 9,name: "龙头企业库",tagnum:10010,}, 
				{curindex: 2,type: 2,name: "科创企业库",tagnum:10010,},
				],
					
				tz_enterinarr:[
					{curindex: 1,type: 9,name: "上市公司",tagnum:10010,url:'markingEnterpriseist?type=9'},
					{curindex: 2,type: 1,name: "龙头企业",tagnum:10010,url:'markingEnterpriseist?type=1'},
					{curindex: 3,type: 0,name: "全部内资企业",tagnum:10010,url:'markingEnterpriseist?type=0'}, 
				],
				hotindustry:[],hotindustrychild:[], industrycode1:"",industrycode2:'',industryid:0,
				levelList:[{text:'全部',code:0},{text:'中国总部',code:1},{text:"其他企业",code:2}],levelid:0,
				curindex: 5, 
				islogin: false,
				userdata: {}, 
				searchtext: "",
				kwtextsearch: false,
				kwtextsearchtext: "", 
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数  
				provinceid: 0,
				cityid: 0,
				countyid: 0,
				provincedata: [],
				citydata: [],
				countydata: [], 
				enterpristlist: [],  
				orderField: 0, //排序字段 0 分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序    
				exportnum: 0, //导出次数
				exportpop: false, //点击导出按钮弹框显示
				allowexport: false, //后台判断是否可以上传
				exportbtn: true, //loading小 等待转圈圈
				confirmtext: '确认导出',
				iframeurl: '', 
				
				// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
				//外资企业筛选列表：0=注册资本,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
				dimensionList:[ 
					{name:"注册资本",type:0},
					{name:'拿地数量',type:5 }, 
					{name:'拿地面积',type:6 },
					{name:'拿地金额',type:7 },
					// {name:'投资项目数量',type:8 },
					{name:'对外投资',type:17 	},
					{name:'控制企业',type:10},
					{name:'专利数量',type:11},
				 ],
				isShowFreeUserTips:false,
			}
		},
		beforeCreate() {
			// this.bus.$emit('loading', true);
		},  
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			var _this = this;
			this.userdata = this.getuseriformation();
			
			var provinceHidden="&台湾省&香港&澳门";
			var areadata=dataInJs(); 
			this.provincedata = areadata.filter(list=>{
				return provinceHidden.indexOf(list.areaName)<0;
			});
			
			// _this.notionlist=NotionTree; 
		 
		},
		mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
			// console.log('sercatype:', this.searchtype); 
			this.getCompanyList();
			document.title = '外资企业库-产业研究大脑体验版';
		},
		methods: {  
			getLevelId(id){
				this.isShowFreeUserTips = true;
				return;
				this.levelid=id;
				// this.industryid=0;
				this.getCompanyList();
			},
			getIndustryId(step,id){
				this.isShowFreeUserTips = true;
				return;
					if(	id == this.industryid && this.industryid != ""){return;}
				if(step == 2){
					this.industrycode1=id;
					this.industrycode2=""; 
				}else if(step == 3){
					this.industrycode2=id; 
				}
				this.industryid=id; 
				this.getCompanyList(1,'notion',step)
			},
	
			getajaxUrl(apiurl,searchtype) {
				if(searchtype != 'search'){
					this.searchtext="";
				}  
				var industryja1 =this.splicing('industry',this.industrycode1);
				var industryja2 =this.splicing('industry2',this.industrycode2); 
				var kwaja =this.splicing('kw',this.searchtext); 
				var countyidja =this.splicing('county',this.countyid);
				var provinceidja =this.splicing('province',this.provinceid);
				var cityidja =this.splicing('city',this.cityid); 
				var levelja =this.splicing('level',this.levelid); 
				apiurl = apiurl + "?orderField=" + this.orderField + "&orderType=" + this.orderType+kwaja+industryja1+industryja2+countyidja+provinceidja+cityidja + levelja;
				return apiurl;
			},
					//企业列表导出数据
			enlistExport() {
				if (this.exportbtn) {
					this.exportpop = true;
				}
				// console.log(this.userdata.groupType,this.exportnum,this.allowexport,this.total);  
				// var ajaxurl=this.$api.cyl.enterprise.export()+'?token='+this.token+'&type='+this.searchtype+'&search=1&city='+this.cityid+'&province='+this.provinceid+'&county='+this.countyid+notionja+tagaja+kwaja+';
			},
			exportlistFun() { //下载报告
				var _this = this;
				var ajaxurl = this.getajaxUrl(this.$api.cyl.forcapenterprise.export(),'search') + '&token=' + this.userdata.token;
				this.confirmtext = "导出中";
				var iframe = document.getElementById("exportIframe");
				iframe.setAttribute("src", ajaxurl);
				_this.exportnum = this.exportnum--;
				setTimeout(() => {
					_this.confirmtext = "导出成功";
					_this.exportpop = false;
					_this.exportbtn = false;
				}, 5000)
				setTimeout(() => {
					_this.exportbtn = true;
					_this.confirmtext = "确认导出";
					console.log('一分钟冷却计时')
				}, 60000)
			}, 
			//时间/分数升降序
			tablesort(field) {
				this.isShowFreeUserTips = true;
				return;
				if (field == this.orderField) {
					this.orderType = Math.abs(this.orderType - 1);
				} else {
					this.orderField = field;
				}
				this.getCompanyList();
			},
			//搜索关键词
			searchkwfun() {
				this.isShowFreeUserTips = true;
				return;
				this.searchtext = $.trim(this.searchtext);
				// if(this.searchtext!="" || ){
				this.getCompanyList(1,'search');
				// } 
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.isShowFreeUserTips = true;
					return;
					this.searchkwfun();
				}
			},
			pageHandler: function(page) {  
				if(page >1){
					this.isShowFreeUserTips = true;
					return;
				}
				this.getCompanyList(page,'search'); 
			}, 
			getCompanyList(pages,searchtype,notionstep) {
				//页面参数 分页或者地区、概念筛选时使用
				//搜索参数 搜索时使用 其余传空参数
				//概念层级参数 概念选择或者初始化时
				// console.log(pages,searchtype,notionstep)
				this.bus.$emit('loading', true); 
				this.page=pages?pages:1; 
				var _this = this; 
				notionstep=notionstep?notionstep:1;
				if((notionstep == 1 && !pages) || searchtype == "sort"){
					_this.industrycode1='';
					_this.industrycode2=''; 
					_this.hotindustrychild=[];
				}else if(notionstep == 2){ 
					_this.industrycode2=''; 
				}
				var ajaxurl = this.$api.free.forcapenterprise.list();
				// console.log(ajaxurl)
				this.$axios.get(ajaxurl).then(function(res) {  
					console.log('外资企业列表', res.data);
					if (res.data.success) {
						var dataenterlist= res.data.list;
						// _this.exportnum = res.data.extend.exportRemainder;
						// console.log('abc',	_this.exportnum)
						// _this.allowexport = res.data.extend.allowExport;  
						for (var i = 0; i < res.data.list.length; i++) { 
							dataenterlist[i].notionlist = _this.taglistfun(dataenterlist[i].notion, dataenterlist[i].notionCode,'notionsort');
							dataenterlist[i].taglist = _this.taglistfun(dataenterlist[i].tag, dataenterlist[i].tagCode);  
						}  
						//行业数量展示
						// let arrNum=res.data.extend.cityIndustryList.filter(list=>{
						// 		return list.num>0;
						// 	});
						// if((notionstep == 1 && !pages) || searchtype == "sort"){ 
						// 	_this.hotindustry=arrNum;
						// 	_this.hotindustrychild=[];
						// }else if(notionstep == 2 && searchtype == 'notion'){  
						// 	_this.hotindustrychild=_this.industrycode1 != ""? arrNum:[]; 
						// }
						//页数和导出
						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord;
						_this.haspage = res.data.list.length == res.data.pageSize; 
						_this.kwtextsearch = _this.searchtext != "";
						_this.kwtextsearchtext = _this.searchtext;
						_this.exportbtn = true;
						_this.confirmtext = "确认导出"; 
						_this.enterpristlist=dataenterlist; 
						_this.bus.$emit('loading', false);
					} else {
						
					}
				}).catch(function(error) {});
				// console.log(datas);  
			},
			//省份城市选择
			provincechoose(id, i) {
				this.isShowFreeUserTips = true;
				return;
				if(this.provinceid != id){ 
					this.ttsg();
					this.cityid = 0;
					this.countyid = 0;
					this.page = 1;
					this.provinceid = id; 
					this.countydata = [];
					if (i != "all" && this.provincedata[i].children != null) {
						this.citydata = this.provincedata[i].children; 
					} else {
						this.citydata = [];  
					}
						this.getCompanyList(1,'sort'); 
				}
			},
			ttsg(){
				// this.notionlist1=[];
				// this.notionlist2=[];
				// this.notionlist3=[];
				// this.notionlist4=[];
				// this.notionlist5=[];
				// this.notionCode=0;this.chooseNotionlist=[0,0,0,0,0,0];
			},
			choosecity(id, i) {
				this.isShowFreeUserTips = true;
					return;
				//	console.log('choosecity',id);
					if(this.cityid != id){ 
					this.ttsg();
						this.cityid = id;
						this.countyid = 0;
						if (i != "all" && this.citydata[i].children != null) {
							this.countydata = this.citydata[i].children;
						} else {
							this.countydata = [];
						}
						this.page = 1;
						this.getCompanyList(1,'sort');
				}
			},
			choosecounty(id) {
				//	console.log('choosecity',id);
				this.countyid = id;
				this.page = 1;
				this.getCompanyList();
			}, 
			//  
		}
	}
</script>

<style>
</style>
